import React, { PropTypes } from 'react';
import '../../styles/FeedbackButton';

let FeedbackButton = React.createClass({
	propTypes: {
		className: PropTypes.string,
		innerHTML: PropTypes.any,
		onClick: PropTypes.func,
		timeout: PropTypes.number
	},

	handleClick: function(ev) {
		if (this.props.onClick) {
			this.props.onClick(ev);
		}
		// Don't allow focus to persist, because bootstrap applies a color very similar to the active color
		// when a button is focused, and that interferes with the feedback effect visibility
		document.activeElement.blur();

		let timeout;

		if (isNaN(this.props.timeout)) {
			timeout = 1000;
		} else {
			timeout = this.props.timeout;
		}
	},

	render: function() {
		return(
			<button
				className={ 'feedback-button ' + this.props.className }
				onClick={ this.handleClick }
			>
				<span className="active-feedback">
					<i className="glyphicon glyphicon-ok" />
				</span>
				{ this.props.innerHTML }
			</button>
		);
	}
});

module.exports = FeedbackButton;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/FeedbackButton.jsx